import { HttpEvent, HttpEventType, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Config } from 'src/modules/app-template/models/config.model';
import { MainAppService } from 'src/modules/app-template/services/main-app.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let authReq = Config.get().isPortalBackend ? req.clone({
            headers: req.headers
                .set('Authorization', "Bearer " + MainAppService.instance.auth.getToken())
                .set('frontend-version', (window as any).frontendVersion as string ?? '???')
        }) : req;

        return next.handle(authReq).pipe(
            map((event: HttpEvent<any>) => {
                if (event.type == HttpEventType.Response) {
                    MainAppService.instance.backendVersionRetrieved(event.headers.get("backend-version"), event.headers.get("frontend-version"));
                    if (event.status === 401) {
                        // eslint-disable-next-line @typescript-eslint/no-floating-promises
                        MainAppService.instance.auth.clearLogin();
                    }
                }
                return event;
            }),
            catchError(error => {
                MainAppService.instance.handlePortalBackendErrorId(error.headers.get("portal-backend-error-id") as string);
                if (error.status === 401) {
                    // eslint-disable-next-line @typescript-eslint/no-floating-promises
                    MainAppService.instance.auth.clearLogin();
                }
                return throwError(() => error);
            }));
    }
}
